import type { ReactNode } from 'react';

import { DEAL_PULSE } from '../../constants';
import { valueStyles } from '../utils/styles';
import { useDealSummary } from '../../common/DealSummaryProvider';
import DealPulseRow from './DealPulseRow';
import DealSummaryItem from './DealSummaryItem';
import { DealPulseCardStyle, getTopLevelLabelStyles } from './DealPulseCard.style';
import { Box } from '@interstate/components/Box';
import { CustomerInsightsSlideOut } from '../../customerInsights/CustomerInsightsSlideOut';
import { CustomerInsightsTrigger } from '../../customerInsights/CustomerInsightsTrigger';
import { PurchaseHistoryReadyNotification } from '../../customerInsights/PurchaseHistoryReadyNotification';

type DealPulseCardInfo = {
    title: string;
    offerValue: string | number;
    range: ReactNode;
    header?: ReactNode;
    footer?: ReactNode;
};

interface DealPulseCardProps {
    dealPulseCardsInfo: DealPulseCardInfo[];
    defaultExpanded?: boolean;
}

const DealPulseCard = ({ dealPulseCardsInfo, defaultExpanded }: DealPulseCardProps) => {
    const topLevelLabelStyles = getTopLevelLabelStyles();
    const { showDetailedView } = useDealSummary();

    const rows = dealPulseCardsInfo.map(({ title, offerValue, range, header, footer }) => (
        <DealPulseRow key={title} label={title} value={offerValue} range={range} header={header} footer={footer} />
    ));

    const customerInsightsTrigger = <CustomerInsightsTrigger />;
    const customerInsightsPanel = (
        <>
            <CustomerInsightsSlideOut />
            <PurchaseHistoryReadyNotification />
        </>
    );

    if (showDetailedView) {
        return (
            <>
                <DealSummaryItem
                    label={DEAL_PULSE}
                    value=""
                    labelStyles={topLevelLabelStyles}
                    valueStyles={valueStyles}
                    headerAction={customerInsightsTrigger}
                >
                    <Box sx={{ pt: '13px' }}>{rows}</Box>
                </DealSummaryItem>
                {customerInsightsPanel}
            </>
        );
    }

    return (
        <>
            <DealPulseCardStyle>
                <DealSummaryItem
                    defaultExpanded={defaultExpanded}
                    label={DEAL_PULSE}
                    value=""
                    labelStyles={topLevelLabelStyles}
                    valueStyles={valueStyles}
                    headerAction={customerInsightsTrigger}
                >
                    {rows}
                </DealSummaryItem>
            </DealPulseCardStyle>
            {customerInsightsPanel}
        </>
    );
};

export default DealPulseCard;
